export default __webpack_public_path__ + "static/media/031-milk.796feaf5.svg";